import { messages as portugueseMessages } from './pt';
// import { messages as espanholMessages }  from './es';

const messages = {
  ...portugueseMessages,
  // ...espanholMessages
};

export { messages };
